/**
 * Renders a 1080×1080 branded persona share card on a canvas and
 * triggers a PNG download. Pure canvas text — reliable rendering,
 * no image dependencies. Used by the quiz result share section.
 */
export function downloadPersonaCard({ name, icon, tagline, color }) {
  const S = 1080;
  const canvas = document.createElement("canvas");
  canvas.width = S;
  canvas.height = S;
  const ctx = canvas.getContext("2d");

  // Persona-colored background + subtle darker footer band
  ctx.fillStyle = color || "#102945";
  ctx.fillRect(0, 0, S, S);
  ctx.fillStyle = "rgba(0,0,0,0.18)";
  ctx.fillRect(0, S - 190, S, 190);

  ctx.textAlign = "center";
  ctx.fillStyle = "rgba(255,255,255,0.75)";
  ctx.font = "600 34px Georgia, serif";
  ctx.fillText("MY MONEYMIND\u2122 PERSONA", S / 2, 150);

  ctx.font = "160px serif";
  ctx.fillText(icon || "\u2728", S / 2, 380);

  ctx.fillStyle = "#FFFFFF";
  ctx.font = "bold 92px Georgia, serif";
  wrapText(ctx, name, S / 2, 520, S - 160, 100);

  ctx.fillStyle = "rgba(255,255,255,0.92)";
  ctx.font = "italic 44px Georgia, serif";
  wrapText(ctx, `\u201C${tagline}\u201D`, S / 2, 660, S - 220, 58);

  ctx.fillStyle = "#FFFFFF";
  ctx.font = "600 40px Georgia, serif";
  ctx.fillText("What's your MoneyMind?", S / 2, S - 110);
  ctx.fillStyle = "rgba(255,255,255,0.85)";
  ctx.font = "36px Georgia, serif";
  ctx.fillText("financialhabitstosucceed.com/quiz", S / 2, S - 55);

  canvas.toBlob((blob) => {
    if (!blob) return;
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `moneymind-${(name || "persona").toLowerCase().replace(/\W+/g, "-")}.png`;
    a.click();
    URL.revokeObjectURL(a.href);
  }, "image/png");
}

function wrapText(ctx, text, x, y, maxWidth, lineHeight) {
  const words = (text || "").split(" ");
  let line = "";
  let yy = y;
  for (const w of words) {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width > maxWidth && line) {
      ctx.fillText(line, x, yy);
      line = w;
      yy += lineHeight;
    } else {
      line = test;
    }
  }
  if (line) ctx.fillText(line, x, yy);
}
